import { render, staticRenderFns } from "./CaseTasklistContainer.vue?vue&type=template&id=48088ccd"
import script from "./CaseTasklistContainer.vue?vue&type=script&lang=js"
export * from "./CaseTasklistContainer.vue?vue&type=script&lang=js"
import style0 from "./CaseTasklistContainer.vue?vue&type=style&index=0&id=48088ccd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports